<template>
   <v-layout>
    <v-main>
      <v-container fluid>
  <v-row no-gutters>
    <v-col cols="12" v-if="!dialog" style="position: relative">
      <TBDataTable
        model=""
        title="Manage Data Model"
        :addons="['search', 'columns']"
        :exportOptions="['excel', 'csv','pdf']"
        :extendedMenus="['edit', 'delete', 'view']"
        @addData="addData"
        @rowAction="rowActions"
        @filter="true"
        @columnSelection="true"
        @saveLayout="true"
        :pagination="true"
        :infiniteScroll="true"
        :defaultLayout="null"
        :data="CompanyData"
        :defaultColumns="column"
        @filterData="applyFilter"
        :hideAdd="hideAdd"
        :noExport="noExport"
        :noTableTitle="false"
        :noTableOptions="noTableOptions"
        :miniTab="miniTab"
        @rowClicked="menuSelected"
        @tableRowCliced="tableRowCliced"
        :showList="showList"
        :sideMenu="sideMenu"
        :selectedItem="selectedItem"
        :checkBox="false"
        :itemPerpage="10"
        :loading = "loading"
        @closeDialog="closeDialog"
      />
    </v-col>
    <!-- <v-col cols="12" v-else>
        <CreateDataModel
          :id="editId"
          :viewType="viewType"
          @close-dialog="closeDialog"
          :showReadOnly="showReadonly"
        />
      </v-col> -->
  </v-row>
  <!-- <v-dialog v-model="editModel" width="100%">
    <v-card class="pa-4">
      <div class="d-flex" style="justify-content: space-between">
        <h2 class="mb-6">Multiple Model</h2>
        <span
          style="font-size: 20px; cursor: pointer"
          @click="closeEditModel"
          class="mdi mr-4 mdi-close"
        ></span>
      </div>
      <MultipleModel
        :companyData="company_data"
        :multiModel="multi_Model"
        :name="modelName"
        :database_name="databaseName"
        :showReadOnly="showReadonly"
        :editId="editId"
        @closeDialog="closeEditModel"
      />
    </v-card>
  </v-dialog> -->
  <!-- <v-dialog v-model="updateModel" width="50%">
    <updateDataModel
      :showReadOnly="showReadonly"
      :updateData="updateData"
      @close-dialog="closeEditModel"
    />
  </v-dialog> -->
  </v-container>
  </v-main>
  </v-layout> 
</template>

<script>
// import CreateDataModel from "../CreateDataModel.vue";
import { TBDataTable } from "@tiburadev/table-vue3";
import DataModelsService from "../../api/service/DataModel/DataModelsService";
// import MultipleModel from "./MultipleModel.vue";
// import updateDataModel from "../updateDataModel.vue";
// import moment from "moment";
// import CompanieService from "../../api/service/companieService";

export default {
  components: {
    TBDataTable,
    // MultipleModel,
    // updateDataModel
  },
  props: {
    noTableTitle: {
      type: Boolean,
      default: false,
    },
    noExport: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialog: false,
      editId: null,
      showReadonly: true,
      viewType: null,
      updateData: {},
      CompanyData: [],
      company_data: [],
      editModel: false,
      updateModel: false,
      multi_Model: [],
      databaseName: null,
      modelName: null,
      loading: true,
      column: [
        {
          column_required: 1,
          column_name: "name",
          label: "Model",
        },
        {
          column_required: 1,
          column_name: "model",
          label: "Table Name",
        },
        {
          column_required: 1,
          column_name: "model_type",
          label: "Model Type",
        },
        {
          column_required: 1,
          column_name: "created",
          label: "Created",
          type: "date",
          data_type: "datetime"
        },
        {
          column_required: 1,
          column_name: "modified",
          label: "Modified",
          type: "date",
          data_type: "datetime"
        },
        {
          column_required: 1,
          column_name: "active",
          label: "Status",
        },
      ]
    }
  },
  mounted() {
    this.getDataModel();
  },
  methods: {
    addData() {
      // this.editId = null;
      // this.viewType = "add";
      // this.showReadonly = false;
      // this.dialog = true;
      this.$router.push("/addmodel");
    },
    closeDialog() {
      this.dialog = false;
      this.getDataModel();
    },
    async getCompaniesData() {
      // let res = await CompanieService.getAll();
      // this.company_data = res.length > 0 ? res : [];
    },
    async deleteTheData(data) {
      console.log(data,"trdtrtd")
      try {
        await DataModelsService.removeOne(data);
        this.getDataModel();
      } catch (e) {
        console.log(e, "error");
      }
    },
    async getDataModel() {
      let userData = localStorage.getItem("user_details");
      userData = userData ? JSON.parse(userData) : {};
      console.log(userData, "userData");
      try {
        let res = await DataModelsService.findAll({
          active: 1,
          deleted: 0,
          // created_by: userData.id,
        });
        this.CompanyData = res && res.length > 0 ? res : [];
        this.loading = false;
      } catch (e) {
        console.log(e);
        this.loading = false;
      }
    },
    tableRowCliced(item) {
      console.log(item, "tableRowCliced");
    },
    rowActions($event) {
      this.viewType = $event.type;
      this.editId = $event.data.id;
      this.updateData = $event.data;
      if (this.viewType == "delete") {
        this.deleteTheData($event.data);
      }
      if (this.viewType === "edit" || this.viewType === "view") {
        this.getDataModel();
        // this.getCompaniesData();
        if ($event.data.model_type === "multiple_model") {
          this.editModel = true;
          this.multi_Model = JSON.parse($event.data.multi_model);
          this.modelName = $event.data.name;
          this.databaseName = $event.data.database_name;
          // if (this.viewType === "view") {
          //   this.showReadonly = true;
          // }
        } else {
          if (this.viewType === "edit" || this.viewType === "view") {
            if ($event.data.model_type == "query") {
              this.updateModel = true;
            } else {
              if(this.viewType === "edit"){
                this.showReadonly = false;
              }
              this.$router.push({
                path: "/editmodel",
                query: { name: $event.data.name, model_id: $event.data.id, readOnly: this.showReadonly},
              });              
            }
          } else {
            this.$router.push({
              path: "/viewmodel",
              query: { name: $event.data.name, model_id: $event.data.id },
            });
            this.showReadonly = true;
          }
        }
      }
    },
    closeEditModel() {
      this.editModel = false;
      this.updateModel = false;
      this.getDataModel();
      this.getCompaniesData();
    }
  }
};
</script>

<style scoped>
h2 {
  font-size: 20px;
}
</style>
